import { createGenericStore, ngrxEvent } from '@core/ngrx-legacy';
import type { SkillsIdeate, SkillsIdeateStartParams } from '@core/tellent-skills-types';

const { actions, reducer, namespace } = createGenericStore<Record<string, never>>()(
  'SkillsIdeate',
  {
    initialState: {},
    actions: () => ({
      startIdeate: ngrxEvent<SkillsIdeateStartParams>(),
      startIdeateSuccess: ngrxEvent<{ data: SkillsIdeate }>(),
      startIdeateFailed: ngrxEvent<unknown>(),
      fetchIdeate: ngrxEvent<{ id: number }>(),
      fetchIdeateSuccess: ngrxEvent<{ data: SkillsIdeate }>(),
      fetchIdeateFailed: ngrxEvent<unknown>(),
    }),
  },
);

const SkillsIdeateActions: Pick<
  typeof actions,
  | 'startIdeate'
  | 'startIdeateSuccess'
  | 'startIdeateFailed'
  | 'fetchIdeate'
  | 'fetchIdeateSuccess'
  | 'fetchIdeateFailed'
> = actions;

export { reducer as SkillsIdeateReducer, namespace as SkillsIdeateNamespace, SkillsIdeateActions };
